import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { categories } from "../mock";

const Categories = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
          <div>
            <span className="text-[#00A859] text-sm font-bold uppercase tracking-[3px] mb-3 block">
              Catalogo Prodotti
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-[#0B2545] tracking-tight">
              Le nostre categorie
            </h2>
            <p className="text-gray-600 mt-3 max-w-2xl">
              Tutto ciò di cui hai bisogno per la tua attività: dai prodotti per
              la ferramenta ai servizi di logistica e manutenzione.
            </p>
          </div>
          <Link
            to="/prodotti"
            className="inline-flex items-center gap-2 text-[#00A859] font-bold uppercase text-sm tracking-wide hover:gap-3 transition-all"
          >
            Vedi tutto <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/prodotti/${cat.slug}`}
              className="group relative overflow-hidden rounded-2xl bg-white shadow-sm hover:shadow-2xl transition-all duration-500"
            >
              <div className="aspect-[4/3] overflow-hidden bg-gray-100">
                <img
                  src={cat.image}
                  alt={cat.name}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B2545]/85 via-[#0B2545]/20 to-transparent" />
              </div>
              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                <h3 className="text-2xl font-extrabold text-white mb-2 tracking-tight">
                  {cat.name}
                </h3>
                <div className="flex flex-wrap gap-1.5 mb-3 max-h-0 overflow-hidden opacity-0 group-hover:max-h-32 group-hover:opacity-100 transition-all duration-500">
                  {cat.sub.slice(0, 4).map((s) => (
                    <span
                      key={s}
                      className="text-[11px] text-white/90 bg-white/15 backdrop-blur-sm px-2.5 py-1 rounded-full border border-white/20"
                    >
                      {s}
                    </span>
                  ))}
                </div>
                <div className="inline-flex items-center gap-2 text-[#00A859] font-bold text-sm uppercase tracking-wider">
                  <span className="bg-[#00A859] text-white px-4 py-2 rounded-full group-hover:bg-white group-hover:text-[#00A859] transition-colors">
                    Scopri <ArrowRight className="w-3.5 h-3.5 inline ml-1" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
